import { UserPayload } from '_api/types';

const DefaultNewUser: UserPayload = {
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
};

export default DefaultNewUser;
